import AllTrainingMaterials from 'pages/Student/AllTrainingMaterials/Index';

const StudentTrainingMaterial = () => {
  return <AllTrainingMaterials />;
};

export default StudentTrainingMaterial;
